const pageContentContainerEl = document.querySelector('.page-content');
const screenReaderEls = document.querySelectorAll('.js-screen-reader');

/**
 * Returns back a NodeList of focusable elements
 * that exist within the passed parent HTMLElement, or
 * an empty array if no parent passed.
 *
 * @param {HTMLElement} parent HTML element
 * @returns {(NodeList|Array)} The focusable elements that we can find
 */
const getAllFocusableElements = (parent) => {
    if (!parent) {
        console.warn('You need to pass a parent HTMLElement');
        return []; // Return array so length queries will work
    }

    return Array.from(parent.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)'
    )).filter(el => el.offsetParent !== null);
};

screenReaderEls.forEach(sreaderEl => {
    sreaderEl.addEventListener('click', (event) => {
        event.preventDefault();

        const target = event.currentTarget;
        const targetID = target.getAttribute('id');
        if (targetID === 'tomain') {
            getAllFocusableElements(pageContentContainerEl)[0].focus();
        }

        const parentEl = target.closest('.skip-section');
        setTimeout(function() {
            if (parentEl.classList.contains('skip-section') && parentEl.classList.contains('showing') && parentEl.querySelectorAll('a:focus').length == 0) {
                parentEl.classList.remove('showing');
            }
        }, 1);
    });

    sreaderEl.addEventListener('focus', (event) => {
        event.preventDefault();

        const target = event.currentTarget;
        const parentEl = target.closest('.skip-section');
        if (parentEl.classList.contains('skip-section')) {
            parentEl.classList.add('showing');
        }
    });

    sreaderEl.addEventListener('blur', (event) => {
        event.preventDefault();

        const target = event.currentTarget;
        const parentEl = target.closest('.skip-section');
        setTimeout(function() {
            if (parentEl.classList.contains('skip-section') && parentEl.classList.contains('showing') && parentEl.querySelectorAll('a:focus').length == 0) {
                parentEl.classList.remove('showing');
            }
        }, 1);
    });
});